import React from 'react';

import { LayoutRenderer } from './types';

const SECONDARY_SLOTS = 6;

export const WideGridLayout: LayoutRenderer = ({ children }) => {
  const nodes = React.Children.toArray(children).filter(Boolean);
  const [hero, ...rest] = nodes;
  const secondaryTiles = rest.slice(0, SECONDARY_SLOTS);

  if (!hero) return null;

  return (
    <div className="itv-row-collection__wide-grid">
      <div className="itv-row-collection__wide-grid-primary">{hero}</div>
      <div className="itv-row-collection__wide-grid-secondary">
        {secondaryTiles.map((tile, index) => (
          <div key={`wide-grid-secondary-cell-${index}`} className="itv-row-collection__wide-grid-cell">
            {tile}
          </div>
        ))}
      </div>
    </div>
  );
};
